"use client";

import {JSX} from "react";

import {type LocationOption} from "@/features/locations";
import {MobileSearchView} from "@/features/rental/mobile-search";
import {type SimpleSearchVariant, SimpleSearchView} from "@/features/rental/simple-search/ui/simple-search.view";

import {useMatchMedia} from "@/shared/hooks/dom/use-match-media";

interface ResponsiveSearchViewProps {
    className?: string;
    initialLocation?: LocationOption;
    /** Desktop search variant; mobile always uses the mobile search */
    desktopVariant?: SimpleSearchVariant;
    submitLabel?: string;
}

export function ResponsiveSearchView({className, initialLocation, desktopVariant, submitLabel}: ResponsiveSearchViewProps): JSX.Element {
    const isMobile = useMatchMedia({maxWidth: 767});
    return isMobile ? (
        <MobileSearchView className={className} initialLocation={initialLocation} />
    ) : (
        <SimpleSearchView className={className} initialLocation={initialLocation} variant={desktopVariant} submitLabel={submitLabel} />
    );
}
